import React, { Component } from "react";
import { withRouter } from "react-router-dom";
class Header extends Component {
    downloadFile = () => {
        var url = "/indahgeoportal/api/GetData/GetPDFFile";
        //window.location = url;
        window.open(url, "_blank", "", true);

    };

    render() {
        const path = this.props.location.pathname.split("/")[1].toLowerCase();
        let header = "Service Catalog";

        //console.log(path);
        if (path === 'checkout') {
            header = 'Checkout'
        } else if (path === 'paymentresponse') {
            header = 'Order Details'
        } else if (path === 'userdefinedregion') {
            header = 'User Defined Region'
        } else if (path === 'UnavailableProduct') {
            header = 'Unavailable Product'
        } else if (path === 'downloadablegisdata') {
            header = 'Downloadable GIS Data'
        } else if (path === 'stpdata') {
            header = 'Public STP Data'
        } else if (path === 'admin') {
            header = 'Admin Dashboard'
        }


        return (
            <div className="hearder-bar clearfloat">
                <div className="row m-0">
                    <div className="col-sm-6 text-center">
                        <h3>{header}</h3>
                    </div>
                    <div className="col-sm-6 text-right pt-4">
                        <button type="button" onClick={() => this.downloadFile()} className="btn btn-light text-capitalize font-weight-bold">User Manual</button>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Header);


// WEBPACK FOOTER //
// ./src/components/Home/Header.js